import Cookies from 'js-cookie'

export interface CookieOptions {
  expires?: number | Date
  path?: string
  domain?: string
  secure?: boolean
  sameSite?: 'strict' | 'lax' | 'none'
  httpOnly?: boolean
}

export const setCookie = (
  name: string,
  value: string,
  options?: CookieOptions,
): void => {
  try {
    Cookies.set(name, value, options)
  } catch (error) {
    console.error('Error setting cookie:', error)
  }
}

export const getCookie = (name: string): string | undefined => {
  try {
    return Cookies.get(name)
  } catch (error) {
    console.error('Error getting cookie:', error)
    return undefined
  }
}

export const getAllCookies = (): { [key: string]: string } => {
  try {
    return Cookies.get()
  } catch (error) {
    console.error('Error getting all cookies:', error)
    return {}
  }
}

export const deleteCookie = (
  name: string,
  options?: Pick<CookieOptions, 'path' | 'domain'>,
): void => {
  try {
    Cookies.remove(name, options)
  } catch (error) {
    console.error('Error deleting cookie:', error)
  }
}

export const cookieExists = (name: string): boolean => {
  return getCookie(name) !== undefined
}

export const setJsonCookie = (
  name: string,
  value: any,
  options?: CookieOptions,
): void => {
  try {
    setCookie(name, JSON.stringify(value), options)
  } catch (error) {
    console.error('Error setting JSON cookie:', error)
  }
}

export const getJsonCookie = <T = any>(name: string): T | null => {
  try {
    const value = getCookie(name)
    if (!value) return null
    return JSON.parse(value) as T
  } catch (error) {
    console.error('Error parsing JSON cookie:', error)
    return null
  }
}
